<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-epigraph element-without-heading" id="epigraph">
<div class="text" id="epigraph-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center">Incandescent trees hide presents bought.</p>
<p class="alignment-block-content alignment-block-content-center">A tale of a saviour’s birth,</p>
<p class="alignment-block-content alignment-block-content-center">A child</p>
<p class="alignment-block-content alignment-block-content-center">Empowered to save the earth.</p>
<p class="alignment-block-content alignment-block-content-center">A fear insidious, a vengeance sought.</p>
<p class="alignment-block-content alignment-block-content-center">A cry for help amidst darkness</p>
<p class="alignment-block-content alignment-block-content-center">Developing feelings fraught.</p>
<p class="alignment-block-content alignment-block-content-center">Unjoyful.</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?26723b24